import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
import {
  HomeIcon,
  BuildingOffice2Icon,
  Square3Stack3DIcon,
} from "@heroicons/react/24/solid";
import toast from "react-hot-toast";
const EditBooking = ({ setLoadEditBooking, currentBooking }) => {
  console.log(currentBooking);
  const [load, setLoad] = useState(false);
  const [building, setBuilding] = useState([]);
  const [floor, setFloor] = useState([currentBooking.floorDetails]);
  const [rooms, setRooms] = useState([]);
  const [isChangeSectionVisible, setIsChangeSectionVisible] = useState(false);
  const [floorNumber, setFloorNumber] = useState(0);
  const [buildingId, setBuildingId] = useState("");
  const [bed, setBed] = useState([]);
  const [currentRoom, setCurrentRoom] = useState({});
  const [bedValue, setBedValue] = useState("");

  console.log("This is currentBooking: ", currentBooking);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      roomId: currentBooking?.roomId?._id,
      bedId: currentBooking?.bedId?._id,
      bookingAmount: currentBooking?.bookingAmount,
      comments: currentBooking?.comments,
      email: currentBooking?.email,
      floorNo: currentBooking?.floorNo,
      hostelName: currentBooking?.hostelName?._id,
      joiningDate: currentBooking?.joiningDate
        ? new Date(currentBooking?.joiningDate).toISOString().substring(0, 10)
        : "",
      mobileNumber: currentBooking?.mobileNumber,
      name: currentBooking?.name,
      source: currentBooking?.source,
    },
  });

  const onSubmit = (data) => {
    console.log("i am data on submit--->", data);
    setLoad(true);
    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/booking/update_booking/${currentBooking._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        toast.success(response.data.message);
        setLoad(false);
        setLoadEditBooking(false);
      })
      .catch((error) => {
        setLoad(false);
        console.log(error);
        toast.error(error.response.data.message);
      });
  };

  // // Handle floor selection
  // const handleFloorChange = (floorNumber) => {
  //   setFloorNumber(floorNumber);

  //   const selectedFloor = floor.find(
  //     (f) => f.floorNumber === Number(floorNumber)
  //   );
  //   if (selectedFloor) {
  //     // Generate room numbers based on the number of rooms on the selected floor
  //     const roomNumbers = Array.from(
  //       { length: selectedFloor.numberOfRooms },
  //       (_, index) => index + 1
  //     );
  //     setRooms(roomNumbers); // Set the room numbers dynamically
  //   }
  // };

  const fetchAllBuildings = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("fhghgjgj---->", response.data.data);
        setBuilding(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getFloors = (id) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_floors_by_building/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am floor--->", response.data);
        setFloor(response.data.data.floorDetails);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getConfiguredRoomByBuilding = (floorNumber) => {
    setFloorNumber(floorNumber);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rooms/get_configured_room_by_building/${buildingId}/${floorNumber}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am floor--->", response.data);
        setRooms(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const handleBedChange = (roomData) => {
  //   setCurrentRoom(roomData);
  //   const beds = rooms.find((room) => {
  //     return room.roomNumber == roomData.roomNumber;
  //   });
  //   setBed(beds.bedsAvailable);
  // };

  const handleBed = (id) => {
    const myData = {
      roomId: id,
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/beds/get-beds-by-room-id`,
      headers: {
        "Content-Type": "application/json",
      },
      data: myData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("----beds array-->", response.data.data);
        setBed(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAllBuildings();
  }, []);
  return (
    <div className="bg-[#00000070] fixed inset-0 w-full z-50 flex items-center justify-center min-h-screen">
      <div className="relative h-[30rem] md:h-[37rem] overflow-y-scroll bg-white p-8 lg:py-8 lg:px-16 rounded-lg shadow-lg w-full max-w-5xl">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-center">Edit Booking</h2>
          <AiFillCloseCircle
            onClick={() => setLoadEditBooking(false)}
            className="cursor-pointe cursor-pointer text-primaryColor absolute top-4 right-4"
            size={30}
          />
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Name"
                className={`mt-1 block w-full border ${
                  errors.name ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("name", { required: true })}
              />
            </div>
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Mob Number <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Mobile Number"
                maxLength={10}
                className={`mt-1 block w-full border ${
                  errors.mobileNumber ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("mobileNumber", {
                  required: "Mobile number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Mobile number must be 10 digits",
                  },
                })}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);
                }}
              />
              {errors.mobileNumber && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.mobileNumber.message}
                </p>
              )}
            </div>

            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Email ID <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                placeholder="Email Id"
                className={`mt-1 block w-full border ${
                  errors.email ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("email", { required: true })}
              />
            </div>

            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Source
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.source ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("source")}
              >
                <option value="">Select Source</option>
                <option value="Google">Google</option>
                <option value="Social Media">Social Media</option>
                <option value="Referral">Referral</option>
                <option value="Walk In">Walk In</option>
                <option value="Institute Referral">Institute Referral</option>
                <option value="Others">Others</option>
              </select>
            </div>

            <div className="col-span-1 relative">
              <label className="block text-sm font-medium text-primaryTextColor">
                Joining Date <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                placeholder="dd/mm/yyyy"
                className={`mt-1 block w-full border ${
                  errors.joiningDate ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("joiningDate", { required: true })}
                onBlur={(e) => {
                  const value = e.target.value;

                  if (value) {
                    const selectedDate = new Date(value);
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    if (selectedDate < today) {
                      toast.error("Joining date cannot be in the past");
                      setValue("joiningDate", "");
                      e.target.value = "";
                    }
                  }
                }}
              />
            </div>

            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Booking Amount <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                placeholder="₹ Enter The Booking Amount"
                className={`mt-1 block w-full border ${
                  errors.bookingAmount ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("bookingAmount", { required: true, min: 0 })}
              />
            </div>

            <div className="col-span-2">
              <label className="block text-sm font-medium text-primaryTextColor">
                Comments
              </label>
              <textarea
                type="text"
                placeholder="Write Your Comments"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                {...register("comments")}
              />
            </div>

            <div className="bg-white shadow-md rounded-lg overflow-hidden max-w-md">
              <div className="flex items-center p-4">
                <div className="flex-shrink-0 bg-blue-500 rounded-full p-3">
                  <BuildingOffice2Icon className="h-6 w-6 text-white" />
                </div>
                <div className="ml-4 flex-grow">
                  <h2 className="text-lg font-semibold text-gray-800">
                    Current Building
                  </h2>
                  <div className="mt-1 flex items-center text-sm text-gray-600">
                    <HomeIcon className="h-4 w-4 mr-1" />
                    <span>{currentBooking?.hostelName?.nameBuilding}</span>
                    <Square3Stack3DIcon className="h-4 w-4 ml-3 mr-1" />
                    <span>Floor {currentBooking?.floorNo}</span>
                  </div>
                  <div className="mt-1 flex items-center justify-between">
                    <div className="flex flex-col">
                      <span className="text-sm font-medium text-blue-600">
                        Room : R-F{currentBooking.floorNo}
                        {String(currentBooking?.roomId?.roomNumber).padStart(
                          3,
                          "0"
                        )}
                      </span>
                      <span className="text-sm font-medium text-blue-600">
                        Bed Number : {currentBooking?.bedId?.bedNumber}
                      </span>
                    </div>
                    <button
                      type="button"
                      onClick={(e) => {
                        setIsChangeSectionVisible(!isChangeSectionVisible);
                      }}
                      className="px-3 py-1 bg-primaryColor  text-white text-sm font-medium rounded hover:bg-primaryBtnHoverColor focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition duration-150 ease-in-out"
                    >
                      {isChangeSectionVisible ? "Close" : "Change"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ----------------------Danger Zone Start---------------------- */}
          <div className="lg:grid lg:grid-cols-2 lg:gap-6">
            {/* building name */}
            <div
              className={` space-y-2 mt-6 ${
                isChangeSectionVisible ? "block" : "hidden"
              }`}
            >
              <label className="block text-sm font-medium text-primaryTextColor">
                Building Name <span className="text-red-500">*</span>
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.hostelName ? "" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("hostelName")}
                onChange={(e) => {
                  getFloors(e.target.value);
                  setBuildingId(e.target.value);
                }}
              >
                <option value="">Select Hostel</option>
                {building.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.nameBuilding}
                  </option>
                ))}
              </select>
            </div>
            {/* floor no */}
            <div
              className={` space-y-2 mt-6 ${
                isChangeSectionVisible ? "block" : "hidden"
              }`}
            >
              <label className="block text-sm font-medium text-primaryTextColor">
                Floor No <span className="text-red-500">*</span>
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.floorNo ? "" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("floorNo")}
                onChange={(e) => getConfiguredRoomByBuilding(e.target.value)}
              >
                <option value="">Select a floor</option>
                {floor?.map((f, index) => (
                  <option key={index} value={f?.floorNumber}>
                    Floor-{f?.floorNumber}
                  </option>
                ))}
              </select>
            </div>
            {/* room no */}
            <div
              className={` space-y-2 mt-3 ${
                isChangeSectionVisible ? "block" : "hidden"
              }`}
            >
              <label className="block text-sm font-medium text-primaryTextColor">
                Available Rooms <span className="text-red-500">*</span>
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.roomId ? "" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("roomId")}
                onChange={(e) => {
                  // handleBedChange(selectedRoom);
                  handleBed(e.target.value);
                  setBedValue("");
                }}
              >
                <option value="">Select Room Number</option>
                {rooms.map((room, index) => (
                  <option key={index} value={String(room._id)}>
                    R-F{floorNumber}
                    {String(room.roomNumber).padStart(3, "0")}
                  </option>
                ))}
              </select>
            </div>
            {/* {bed selection} */}
            <div
              className={` space-y-2 mt-3 ${
                isChangeSectionVisible ? "block" : "hidden"
              }`}
            >
              <label className="block text-sm font-medium text-primaryTextColor">
                Available Beds <span className="text-red-500">*</span>
              </label>
              <select
                value={bedValue}
                className={`mt-1 block w-full border ${
                  errors.bedId ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("bedId")}
                onInput={(e) => setBedValue(e.target.value)}
              >
                <option value="">Select Bed Number</option>
                {bed
                  .sort((a, b) => {
                    const numA = parseInt(a.bedNumber.slice(1)); // Extract the number after 'B'
                    const numB = parseInt(b.bedNumber.slice(1)); // Extract the number after 'B'
                    return numA - numB; // Compare the numbers
                  })
                  .map((bed, index) => (
                    <option
                      key={index}
                      value={bed._id}
                      disabled={bed.isOccupied}
                      style={{
                        color: bed.isOccupied ? "green" : "black",
                      }}
                    >
                      {bed.bedNumber}
                      {bed.isOccupied && "(Occupied)"}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          {/* -----------------------------Danger Zone End--------------------------- */}

          <div className="flex justify-between gap-6 mt-6 tracking-wide flo">
            <button
              onClick={() => setLoadEditBooking(false)}
              type="button"
              className="bg-white w-full border hover:bg-secondaryTextColor px-4 py-2 rounded-md"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-primaryBtnColor hover:bg-primaryBtnHoverColor w-full text-white px-4 py-2 rounded-md"
            >
              {"Save"}
            </button>
          </div>
        </form>
      </div>
      {load && (
        <div className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
          <span class="loader"></span>
        </div>
      )}
    </div>
  );
};

export default EditBooking;
